import { RoutesService, eLayoutType, } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: (routes: RoutesService) => () => {
      routes.add([
        {
          path: '/placeholder',
          name: 'p1',
          iconClass: '',
          order: 1,
          layout: eLayoutType.application,
        },
        {
          path: '/placeholder2',
          name: 'p2',
          iconClass: '',
          order: 2,
          layout: eLayoutType.application,
        },
        {
          path: '/',
          name: '::Menu:Trainings',
          iconClass: 'fas fa-book-reader',
          order: 3,
          layout: eLayoutType.application,
        },
        {
          path: '/topics',
          name: '::Topics',
          iconClass: 'fas fa-info-circle',
          order: 4,
          layout: eLayoutType.application,
        },
        {
          path: '/areas',
          name: '::Menu:Areas',
          iconClass: 'fas fas fa-boxes',
          order: 5,
          layout: eLayoutType.application,
        },
        {
          path: '/units',
          name: '::Units',
          iconClass: 'fas fas fa-map-marker',
          order: 6,
          layout: eLayoutType.application,
        },
        {
          path: '/training-template',
          name: '::Menu:TrainingTemplate',
          iconClass: 'fas fa-book-open',
          order: 7,
          layout: eLayoutType.application,
        },
        {
          path: '/reports',
          name: '::Menu:Reports',
          iconClass: 'fas fa-clipboard-list',
          order: 8,
          layout: eLayoutType.application,
        },
        {
          path: '/participants',
          name: '::Participants',
          iconClass: 'fas fa-users',
          order: 9,
          layout: eLayoutType.application,
          requiredPolicy: 'TrainingTracking.Participant',
        },
      ]);
    },
    deps: [RoutesService],
    multi: true,
  },
];
